<template>
    <div
        class="confirm-wrapper"
        :class="{
            'pause' : modalType === 'pause', 'stop' : modalType === 'stop',
            'warning' : modalType === 'warning', 'error': modalType === 'error'
        }"
    >
        <div class="confirm">
            <div class="confirm-header">
                Warning
            </div>

            <div class="confirm-content">
                {{ modalDesc }}
            </div>

            <div class="confirm-controls">
                <button
                    class="cancel"
                    @click="cancel()"
                    v-if="modalType !== 'error'"
                >
                    Cancel
                </button>

                <button
                    class="ok"
                    @click="ok()"
                    v-if="modalType !== 'error'"
                >
                    Ok
                </button>

                <button
                    class="ok-error"
                    @click="cancel()"
                    v-if="modalType === 'error'"
                >
                    Ok
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import { mapFields } from 'vuex-map-fields'

export default {
	computed: {
        ...mapFields('modal', [
            'modalType',
            'modalDesc',
            'storeAction',
			'storePayload',
			'action'
        ]),
	},

	methods: {
		async ok () {
			await this.$store.commit('modal/closeSpecificModal', { modalName: 'confirm-modal'})
			
			if (this.storeAction || this.storePayload) {
				this.$store.dispatch(this.storeAction, this.storePayload)
				return
			}

			if (this.action) {
				this.action()
			}
		},

		async cancel () {
            this.$store.dispatch('modal/closeModal')
		}
	}
}
</script>
<style lang="scss" scoped>
.confirm-wrapper {
    position: fixed;
    height: 100%;
    width: 100%;
    z-index: 9999;
    background-color: rgba(0,0,0,0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;

    .confirm {
        height: 250px;
        width: 375px;
        background: #fff;
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        box-shadow: 0 0 5px #777;
        opacity: 0;

        @include fadeintop(0.5s,0s);

        .confirm-header {
            padding: 20px;
            text-align: center;
            color: #fff;
            font-size: 24px;
            font-weight: 700;
        }

        .confirm-content {
            flex: 1 1 auto;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            color: #575B5C;
            font-size: 18px;
            text-align: center;
            padding: 0 10px;
        }

        .confirm-controls {
            padding-bottom: 30px;
            display: flex;
            justify-content: center;

            button {
                padding: 15px 0;
                width: 100px;
                border-radius: 3px;

                &:not(:last-child) {
                    margin-right: 25px;
                }

                &.cancel {
                    background-color: #fff;
                }

                &.ok {
                    color: #fff;
                }
            }
        }
    }

    &.pause {
        .confirm {
            .confirm-header {
                background-color: #FFB550;
            }

            .confirm-controls {
                button {
                    border: 1px solid #FFB550;
                    &.cancel {
                        color: #FFB550;

                        &:hover {
                            background-color: lighten(#FFB550,30%);
                        }

                        &:active {
                            background-color: lighten(#FFB550,25%);
                        }
                    }

                    &.ok {
                        background-color: #FFB550;

                        &:hover {
                            background-color: darken(#FFB550,5%);
                        }

                        &:active {
                            background-color: darken(#FFB550,10%);
                        }
                    }

                    &:hover {
                        border-color: darken(#FFB550,5%);
                    }

                    &:active {
                        border-color: darken(#FFB550,10%);
                    }
                }
            }
        }
    }

    &.warning {
        .confirm {
            .confirm-header {
                background-color: #F44B4B;
            }

            .confirm-controls {
                button {
                    border: 1px solid #F44B4B;
                    &.cancel {
                        color: #F44B4B;

                        &:hover {
                            background-color: lighten(#F44B4B,35%);
                        }

                        &:active {
                            background-color: lighten(#F44B4B,30%);
                        }
                    }

                    &.ok {
                        background-color: #F44B4B;

                        &:hover {
                            background-color: darken(#F44B4B,5%);
                        }

                        &:active {
                            background-color: darken(#F44B4B,10%);
                        }
                    }

                    &:hover {
                        border-color: darken(#F44B4B,5%);
                    }

                    &:active {
                        border-color: darken(#F44B4B,10%);
                    }
                }
            }
        }
    }

    &.stop {
        .confirm {
            .confirm-header {
                background-color: #E71D36;
            }

            .confirm-controls {
                button {
                    border: 1px solid #E71D36;
                    &.cancel {
                        color: #E71D36;

                        &:hover {
                            background-color: lighten(#E71D36,45%);
                        }

                        &:active {
                            background-color: lighten(#E71D36,40%);
                        }
                    }

                    &.ok {
                        background-color: #E71D36;

                        &:hover {
                            background-color: darken(#E71D36,5%);
                        }

                        &:active {
                            background-color: darken(#E71D36,10%);
                        }
                    }

                    &:hover {
                        border-color: darken(#E71D36,5%);
                    }

                    &:active {
                        border-color: darken(#E71D36,10%);
                    }
                }
            }
        }
    }

    &.error {
        .confirm {
            .confirm-header {
                background-color: #E71D36;
            }

            .confirm-controls {
                button {
                    border: 1px solid #E71D36;
                    &.ok-error {
                        color: #E71D36;
                        background-color: #fff;

                        &:hover {
                            background-color: lighten(#E71D36,45%);
                        }

                        &:active {
                            background-color: lighten(#E71D36,40%);
                        }
                    }
                }
            }
        }
    }
}
</style>
